module.exports = __webpack_public_path__ + "img/vrch-s-kapuci_08_modra.e2998fb4.png";